module.exports = __webpack_public_path__ + "img/mistral.1e94a1be.svg";